import { animalService } from '../_services/';
import alerts from '../_components/alerts';

export const animalAction = {
    getAnimal,
    getAnimalById,
    getAnimalSelect,
    getAnimalByFazenda,
    getAnimalByFazendaSelect,
    getAnimalByFazendaSelectExcluidos,
    reativarAnimal,
    onChangeProps,
    clear
};
function getAnimal(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'animais';
        animalService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeAnimalsList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function getAnimalById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'animais/' + id;
        animalService.get(apiEndpoint)
            .then((response) => {
                dispatch(editAnimalsDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function getAnimalSelect() {
    return dispatch => {
        let apiEndpoint = 'animais/select';
        animalService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeAnimalsList(response.data));
            }).catch((err) => {
                console.log(err);
            })
    };
}
function getAnimalByFazenda(showWaiting, id, page = 1, limit = 10, term = "", excluidos = false) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = `animais/fazenda/${id}?page=${page}&limit=${limit}&excluidos=${excluidos}`;
        if (term) {
            apiEndpoint += `&term=${encodeURIComponent(term)}`;
        }

        animalService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeAnimalsList(response.data.Items, response.data.TotalItems));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function getAnimalByFazendaSelect(id) {
    return dispatch => {
        let apiEndpoint = 'animais/fazenda/select/' + id;
        animalService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeAnimalsList(response.data));
            }).catch((err) => {
                console.log(err);
            })
    };
}

function getAnimalByFazendaSelectExcluidos(id) {
    return dispatch => {
        let apiEndpoint = 'animais/select/excluidos/' + id;
        animalService.get(apiEndpoint)
            .then((response) => {
               dispatch(changeAnimalsList(response.data));
            }).catch((err) => {
                console.log(err);
            })
    };
}

function reativarAnimal(id) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'animais/reativar/' + id;
        animalService.post(apiEndpoint)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(reactivateAnimal());
                    alerts.success("Animal reativado com sucesso!", '/fazenda/' +ret.id_fazenda)
                       } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function onChangeProps(props, event) {
    return dispatch => {
        dispatch(handleOnChangeProps(props, event.target.value));
    }
}
export function changeAnimalsList(animal, totalItems) {
    return {
        type: "FETECHED_ALL_ANIMAL",
        animal: animal,
        totalItems: totalItems
    }
}
export function clear() {
    return {
        type: "ANIMAL_CLEAR"
    };
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editAnimalsDetails(animal) {
    return {
        type: "ANIMAL_DETAIL",
        id: animal.id,
        brinco: animal.brinco,
        nome: animal.nome,
        registro: animal.registro,
        lote: animal.lote,
        data_nascimento: animal.data_nascimento,
        grupo: animal.grupo,
        status: animal.status,
        obs: animal.obs,
        data_cadastro: animal.data_cadastro,
        usuario_cadastro: animal.usuario_cadastro,
        id_cor: animal.id_cor,
        id_fazenda: animal.id_fazenda,
        data_atualizacao: animal.data_atualizacao,
        usuario_atualizacao: animal.usuario_atualizacao,
        data_exclusao: animal.data_exclusao,
        usuario_exclusao: animal.usuario_exclusao,
        id_mae: animal.id_mae,
        id_pai: animal.id_pai,
        id_raca: animal.id_raca,
        data_descarte: animal.data_descarte,
        intencao_descarte: animal.intencao_descarte,
        escore_corporal: animal.escore_corporal,
        bst: animal.bst,
        nome_mae: animal.nome_mae,
        nome_pai: animal.nome_pai
    }
}
export function updatedUserInfo() {
    return {
        type: "ANIMAL_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "ANIMAL_CREATED_SUCCESSFULLY"
    }
}

export function reactivateAnimal() {
    return {
        type: "ANIMAL_REACTIVATED_SUCCESSFULLY"
    }
}

export function deleteAnimalsDetails() {
    return {
        type: "DELETED_ANIMAL_DETAILS"
    }
}